import { IApplicationState } from '../../../../../types/types';

export const isShowSelector = (state: IApplicationState) => state.cookieDialog.isShow;
